import { Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { ErrorMessageService } from 'src/app/common-components/errors/services/error-message.service';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-not-found',
    styleUrls: ['not-found.component.scss'],
    templateUrl: 'not-found.component.html',
    standalone: false
})
export class NotFoundComponent implements OnDestroy {
   @Input() set entityName(value: string) {
      if (value) {
         this.message = `${value} Not Found`;
      }
   }

   @Input() message = 'Page Not Found';

   constructor(private store: Store<AppState>, private errorMessageService: ErrorMessageService) {
      this.errorMessageService.preventErrorMessageDialogDisplay();
   }

   ngOnDestroy(): void {
      this.errorMessageService.allowErrorMessageDialogDisplay();
   }
}
